import { Button, Space } from 'antd'
import * as React from 'react'
import AudioPlayer from 'react-h5-audio-player'

interface Props {
  player: React.RefObject<AudioPlayer> | null
}

// Audio playback rates
const speeds = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]

const Speed = ({ player }: Props) => {
  const [speed, setSpeed] = React.useState(
    player?.current?.audio.current?.playbackRate || 1
  )
  const handleChange = (speed: number): void => {
    if (player && player.current) {
      const audio = player.current.audio.current

      if (audio) {
        audio.playbackRate = speed
        setSpeed(speed)
      }
    }
  }

  return (
    <Space>
      Speed:
      <Button.Group>
        {speeds.map((item, key) => (
          <Button
            type={speed === item ? 'primary' : 'default'}
            onClick={() => handleChange(item)}
            key={key}
          >
            {item}
          </Button>
        ))}
      </Button.Group>
    </Space>
  )
}

export default Speed
